<template>
  <Head title="Planning - Annual Plan" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <annual-plan-screen 
            :plan="plan" 
            :client="client" 
            :plans="plans"
            :results="results" 
            :result_details="result_details"
            :init_types="init_types" 
          ></annual-plan-screen>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  plan: Object,
  client: Object,
  plans: Array,
  results: Object,
  result_details: Array,
  init_types: Array
});
</script>

